// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1v_Eu","form":"styles_form__2S4EP","item":"styles_item__3_-hq"};